import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { useDateTime } from "../../../../../../modules/localization/useDateTime"
import { StandardAlertInfo } from "../../../../alert/StandardAlertInfo"
import { useClosedDeliveryDateNotice } from "../../../hooks/useClosedDeliveryDateNotice"

const useStyles = makeStyles()(() => ({
    banner: {
        width: "100%",
    },
}))

type ClosedDeliveryDateBannerProps = Readonly<{
    merchantId?: number
    deliveryDate: string | null
}>

/**
 * Keeps the "the canteen is closed that day" notice in front of whoever may order anyway —
 * the delivery popover is long closed by the time they reach the cart or the receipt.
 */
export function ClosedDeliveryDateBanner({ merchantId, deliveryDate }: ClosedDeliveryDateBannerProps) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()
    const audience = useClosedDeliveryDateNotice(merchantId, deliveryDate)

    if (!audience || !deliveryDate) return null

    const formattedDate = dateTimeFactory.formatWeekdayLongDate(dateTimeFactory.fromISO(deliveryDate))

    return (
        <LocalizedStrict
            id={
                audience === "admin"
                    ? "create-order-closed-delivery-date-banner-admin"
                    : "create-order-closed-delivery-date-banner-editing"
            }
            vars={{ date: formattedDate }}
            attrs={{ title: true }}
        >
            <StandardAlertInfo title="" severity="error" className={classes.banner} />
        </LocalizedStrict>
    )
}
